<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="medium">
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('modals.request_consultation_report_modal.heading', { name: referringPhysicianName })"
                    :isCenter="true"
                    size="medium"
                ></common-page-header>

                <form-wrapper @submit="handleFormSubmission(data)">
                    <form-row>
                        <form-cell>
                            <textarea-field
                                :label="
                                    $t('modals.request_consultation_report_modal.text_area_label', {
                                        name: referringPhysicianName,
                                    })
                                "
                                :placeholder="
                                    $t('modals.request_consultation_report_modal.text_area_placeholder', {
                                        name: referringPhysicianName,
                                    })
                                "
                                :isRequired="false"
                                :formData="data"
                                valuePath="message"
                                @change="change($event)"
                            ></textarea-field>
                        </form-cell>
                    </form-row>

                    <template #footer>
                        <common-buttons>
                            <common-button
                                :label="$t('modals.request_consultation_report_modal.buttons.send_request')"
                                :isProcessing="isSending"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </template>
                </form-wrapper>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import ReferralsAPI from 'api/ReferralsAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [FormMixin],

        props: {
            isOpen: { type: Boolean, required: true },
            referral: { type: Object, required: true },
        },

        data() {
            return {
                isSending: false,
            }
        },

        computed: {
            referringPhysicianName() {
                if (this.referral.practice?.practiceType === PracticeTypeEnum.ANCILLARY) {
                    return this.referral.practice.name
                } else {
                    return `${this.referral.toUser.firstName} ${this.referral.toUser.lastName}`
                }
            },
        },

        methods: {
            handleFormSubmission(data) {
                this.isSending = true

                ReferralsAPI.requestConsultationReport(this.referral.id, data.message).then(() => {
                    this.isSending = false
                    this.emitEvent({ name: 'sent' })
                })
            },
        },

        watch: {
            isOpen() {
                this.data.message = ''
            },
        },
    }
</script>
